// pgw 24-aug-2026 - for CG login
import { isCgTestingEnabled } from "../../utils/cgTesting";

// pgw 29-oct-2025
let doprint = false;

// pgw 06-may-2026
// let doprint = true;



export async function loginUser(endpoint, username, password) {

	if (doprint) console.log('loginUser, username = ', username);
	if (doprint) console.log('loginUser, password = ', password);



  if (!username) throw new Error('Please provide a username');
  if (!password) throw new Error('Please provide a password to login');

  if (isCgTestingEnabled()) {
    const body = new URLSearchParams();
    body.set("username", username);
    body.set("password", password);

    const response = await fetch("https://www.choirplayer.com/wp-json/myplugin/v1/cglogin", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Accept: "application/json",
      },
      body,
    });

    const result = await response.json();

	if (doprint) console.log('loginUser, response.ok = ', response.ok);
	if (doprint) console.log('loginUser, result.status = ', result.status);
	if (doprint) console.log('loginUser, result.token = ', result.token);


    if (!response.ok || result.status !== "success" || !result.token) {
      throw new Error(result.message || result.error || "ChoirGenius login failed");
    }

    window.localStorage.setItem("AUTH_TOKEN", result.token);

    return {
      data: {
        ID: result.uid || "choirgenius-user",
        displayName: result.name || result.username || username,
        userName: result.username || username,
        email: username,
        subscribed: true,
        guest: false,
        choirGenius: true,
      },
    };
  }

  const loginParams = {
    username64: encodeURIComponent(btoa(username)),
    password64: encodeURIComponent(btoa(password))
  };

  const urlParams = new URLSearchParams(loginParams);
  const requestString = `${endpoint}?${urlParams.toString()}`;
  const response = await fetch(requestString);
  const result = await response.json();

  if (response.status === 200) {
    if (result.status === 'ok') {
      return {
        data: result.user.data
      };
    } else if(result.status === 'error') {
      throw new Error(result.error);
    }
  }

  throw new Error('Login error occurred');
}


export async function checkSubscription(endpoint, session_id) {


	let urlToCache = "" + endpoint + session_id
	if (doprint) console.log('checkSubscription urlToCache = ', urlToCache)
	const cacheresp = await fetch(urlToCache, { cache: 'no-store' });
	if (doprint) console.log('checkSubscription cacheresp.status = ', cacheresp.status)


	let urlToFetch = `${endpoint}${session_id}`
	if (doprint) console.log('checkSubscription endpoint = ', endpoint)
	if (doprint) console.log('checkSubscription session_id = ', session_id)
	if (doprint) console.log('checkSubscription urlToFetch = ', urlToFetch)

	// pgw 15-oct-2025
    // const response = await fetch(`${endpoint}${session_id}`);
    const response = await fetch(`${endpoint}${session_id}`, { cache: 'no-store' });

    const result = await response.json();

	if (doprint) console.log('checkSubscription result = ', result)
	if (doprint) console.log('checkSubscription response.status = ', response.status)

    if (response.status === 200) {
        return {
          userName: result.user_email,
          userEmail: result.user_email,
          subscribed: result.user_role === "1" ? true : false
        };
    } else {
        throw new Error("Error fetching subscription");
    }
    
}